import React, { FC, Fragment } from 'react';
import { useTranslate } from 'react-admin';
import Grid from '@material-ui/core/Grid';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import { makeStyles } from '@material-ui/core/styles';
import { H3, TextField } from '~/components';
import { CardTransaction } from '~/types/TransactionsHistory';
import collectProperties from '~/utils/collectProperties';

const label = (key: string): string => `components.TransactionView.${key}`;

const useStyles = makeStyles((theme) => ({
  innerContent: {
    paddingLeft: theme.spacing(4),
  },
}));

interface CardTransactionViewProps {
  cardTransaction: CardTransaction;
}

const CardTransactionView: FC<CardTransactionViewProps> = (props) => {
  const { cardTransaction } = props;

  const classes = useStyles();

  const translate = useTranslate();
  const t = (key: string): string => translate(label(`cardTransaction.${key}`));

  const properties = collectProperties(cardTransaction.card || {})
    .map((p) => ({
      key: `card.${p.key}`,
      value: p.value,
    }))
    .concat(
      collectProperties(cardTransaction.cardAcceptor || {}).map((p) => ({
        key: `cardAcceptor.${p.key}`,
        value: p.value,
      }))
    );

  const propertyFields = properties.map((p) => {
    return (
      <Grid key={p.key} item xs={12}>
        <TextField label={t(p.key)}>{p.value}</TextField>
      </Grid>
    );
  });

  return (
    <Fragment>
      <H3 icon={<CreditCardIcon />}>{t('_')}</H3>
      <Grid item container spacing={2} className={classes.innerContent}>
        {propertyFields}
      </Grid>
    </Fragment>
  );
};

export default CardTransactionView;
